import React from "react";

export const SignInWelcome = () => {
  return (
    <div className="text-center space-y-4">
      <img 
        src="/Maia_horizontal_color.svg" 
        alt="Maia Logo" 
        className="h-16 w-auto mx-auto"
      />
      <h1 className="text-2xl font-bold">Welcome Back!</h1>
      <p className="text-muted-foreground">
        Please sign in, we were waiting for you!
      </p>
    </div>
  );
};